<template>
  <footer :class="issub?'pc_subFoot':'pc_Foot'">
    <div class="pc_topFoot">
      <div class="top_left pc_contact">
        <h4>嘉宾联系</h4>
        <p><span>张&emsp;红 : 021-64225589 13524902723</span><span>邮箱 : 2021CITS@tunnelling.cn</span></p>
        <h4>参会报名</h4>
        <p><span>张洁萍 : 021-64227731 13641984094</span><span>邮箱 : 2021CITS@tunnelling.cn</span></p>
        <h4>参展报名</h4>
        <p><span>王桂华 : 021-64225589 13166298002</span><span>邮箱 : 2021CITS@tunnelling.cn</span></p>
        <h4>会务联系</h4>
        <p><span>薛&emsp;芹 : 021-68685716 13818967196</span><span>邮箱 : sherry.xue@sheaststar.com</span></p>
      </div>
      <div class="top_left mobile_contact">
        <div class="item">
          <h4>嘉宾联系</h4>
          <p><span>张红: 021-64225589 13524902723</span><span>邮箱: 2021CITS@tunnelling.cn</span></p>
        </div>
        <div class="item">
          <h4>参会报名</h4>
          <p><span>张洁萍: 021-64227731 13641984094</span><span>邮箱: 2021CITS@tunnelling.cn</span></p>
        </div>
        <div class="item">
          <h4>参展报名</h4>
          <p><span>王桂华: 021-64225589 13166298002</span><span>邮箱: 2021CITS@tunnelling.cn</span></p>
        </div>
        <div class="item">
          <h4>会务联系</h4>
          <p><span>薛芹: 021-68685716 13818967196</span><span>邮箱: sherry.xue@sheaststar.com</span></p>
        </div>
      </div>
      <!-- 相关链接 -->
      <div class="AboutLinks">
        <h1>相关链接</h1>
        <div class="content">
          <a href="https://meetingch.tunnelling.cn/" target="_blank" class="linksBox"><img src="../assets/image/links.png" /></a>
          <a href="https://www.tunnelling.cn/PSpecial/ICIM.aspx" target="_blank" class="linksBox"><img src="../assets/image/2016.png" /></a>
        </div>
      </div>
    </div>
    <div class="bot_footer">
      <p>版权所有：2021中国（上海）国际隧道工程研讨会</p>
      <p>备案序号：沪ICP备19007563号-2</p>
      <p>沪公网安备 31010402001139号</p>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'Foot',
    props: {
      issub: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    footer {
      width: 100%;
      overflow: hidden;
    }

    .pc_Foot {
      background: rgba(0, 0, 0, .3);
      color: #ffffff;
    }

    .pc_subFoot {
      background: url(../assets/image/ico_7.png) no-repeat center top;
      margin-top: 80px;
    }

    .pc_topFoot {
      margin: 40px auto;
      display: flex;
      justify-content: center;
    }

    .mobile_contact{
      display: none;
    }

    .top_left{
      margin-right: 200px;
    }

    .top_left h4 {
      font-size: 16px;
    }

    .top_left p{
      font-size: 14px;
      line-height: 24px;
      margin: 0 0 10px;
    }
    
    .top_left p span:last-child{
      margin-left: 10px;
    }

    .AboutLinks h1 {
      font-size: 16px;
      margin-bottom: 20px;
      line-height: 16px;
    }

    .content {
      display: flex;
      align-items: center;
      margin: 20px 0 0;
    }

    .content a {
      display: block;
    }

    .content a:first-child {
      margin-right: 60px;
    }

    .content img {
      width: 140px;
      height: 70px;
    }

    .bot_footer {
      width: 60%;
      text-align: center;
      margin: 40px auto;
    }

    .bot_footer p {
      font-size: 14px;
      line-height: 24px;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .AboutLinks {
      display: none;
    }

    footer {
      width: 100%;
      padding: .6rem 0;
      background: rgba(0, 0, 0, .3);
      font-size: .24rem;
      color: #ffffff;
      text-align: center;
    }

    footer h4 {
      font-size: .28rem;
      margin-right: .2rem;
    }

    .pc_topFoot{
      width: 85%;
      margin: 0 auto;
    }

    .maddie_footer,.bot_footer {
      margin-top: .4rem;
    }

    .bot_footer p{
      margin-bottom: .1rem;
    }

    .pc_contact{
      display: none;
    }

    .top_left .item{
      display: flex;
      align-items: flex-start;
      text-align: left;
    }

    .top_left p{
      margin: 0 0 10px;
    }

    .top_left span{
      display: block;
    }

    .top_left span:last-child{
      margin-top: .1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue